var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16, _path17, _path18, _circle3, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.483 36.116A49.077 49.077 0 0172.5 22.5c19.766 0 36.841 11.61 44.721 28.4-.312-.261-.743-.4-1.221-.4-1.177 0-2 .808-2 1.654v.5h-.5c-.794 0-1.5.705-1.5 1.654s.706 1.654 1.5 1.654c.251 0 .488-.068.697-.19l.383-.222.267.353c.281.373.698.597 1.153.597.484 0 .927-.255 1.207-.673l.259-.386.404.23a2.28 2.28 0 001.13.291l.27-.047C121.056 60.947 122 66.364 122 72c0 27.32-22.18 49.5-49.5 49.5S23 99.32 23 72c0-11.125 3.678-21.397 9.927-29.631l.12.085.337.189-.098.373a2.687 2.687 0 00-.086.676c0 1.499 1.244 2.731 2.8 2.731.683 0 1.307-.238 1.792-.633l.368-.299.319.352c.889.984 2.388 1.657 4.121 1.657 2.882 0 5-1.812 5-3.808v-.5h.5c2.164 0 3.9-1.714 3.9-3.807s-1.736-3.808-3.9-3.808c-.672 0-1.302.165-1.852.456l-.359.189-.259-.312a3.929 3.929 0 00-3.03-1.41c-1.307 0-2.46.627-3.167 1.586l-.254.343-.379-.196-.317-.117z",
    fill: "#def7ec",
    stroke: "#18191b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.223 111.152c11.754-2.441 37.973-.922 48.671-5.378 9.176-3.822-5.805-10.35-14.443-13.136 1.133-1.991 7.653-4.777 31.443 0 3.166.635 6.034 1.307 8.627 2.005-7.197 13.952-20.832 24.05-36.965 26.357H65.444a49.272 49.272 0 01-23.221-9.848z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    d: "M35.5 66h75v28h-75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    fillRule: "nonzero",
    stroke: "#18191b",
    d: "M35.5 70h75v1h-75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 70h82v-2.933L89.461 54.681l-10.075 5.266L61.091 50 30.5 66.17V70z",
    fill: "#ffced0",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b",
    d: "M81.5 74h25v20h-25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 83v-6h-4m14 0v6h4m-18 7h18m-18-2h18",
    fill: "none",
    stroke: "#18191b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    d: "M43.5 90h30v4h-30z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    d: "M45.5 92.5h26V95h-26z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M54 76.5h8V90h-8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "M41 76.5h7v7h-7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M39 76.5h2v7h-2zm9 0h2v7h-2zm18 0h2v7h-2zm10 0h2v7h-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "M68 76.5h8v7h-8zM42.5 60h5m22-1h7m-10-3h5m12 2h4m10 6h9m-68-2h8m58 5h8m-82-.5h23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.27 55.915l-1.163-3.175-.886-1.84c-.312-.261-.743-.4-1.221-.4-1.177 0-2 .808-2 1.654v.5h-.5c-.794 0-1.5.705-1.5 1.654s.706 1.654 1.5 1.654c.251 0 .488-.068.697-.19l.383-.222.267.353c.281.373.698.597 1.153.597.484 0 .927-.255 1.207-.673l.259-.386.404.23a2.28 2.28 0 001.13.291l.27-.047zM38.483 36.116l.317.117.379.196.254-.343A3.923 3.923 0 0142.6 34.5c1.225 0 2.316.551 3.03 1.41l.259.312.359-.189a3.947 3.947 0 011.852-.456c2.164 0 3.9 1.715 3.9 3.808s-1.736 3.807-3.9 3.807h-.5v.5c0 1.996-2.118 3.808-5 3.808-1.733 0-3.232-.673-4.121-1.657l-.319-.352-.368.299a2.827 2.827 0 01-1.792.633c-1.556 0-2.8-1.232-2.8-2.731 0-.234.03-.46.086-.676l.098-.373-.337-.189-.12-.085a47.928 47.928 0 015.556-6.253z",
    fill: "#fff",
    stroke: "#18191b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.147 32.794a.5.5 0 01-1 0v-2.147H30a.5.5 0 010-1h2.147V27.5a.5.5 0 011 0v2.147h2.147a.5.5 0 010 1h-2.147v2.147z",
    fill: "#18191b",
    fillRule: "nonzero"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(1 0 0 -1 21.5 102.294)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(1 0 0 -1 34.5 118.294)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.235 39.071L128.092 20.5H84v28.224l21.235-9.653z",
    fill: "#036d55",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#84e1bc",
    stroke: "#18191b",
    d: "M129 20.5H84v25h45z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 25c4 0 4 4 4 6h-8c0-2 0-6 4-6z",
    fill: "none",
    stroke: "#18191b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 39v-6a2 2 0 00-2-2h-8a2 2 0 00-2 2v6a2 2 0 002 2h8a2 2 0 002-2z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 35v2",
    fill: "none",
    stroke: "#18191b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#18191b",
    transform: "matrix(-1 0 0 1 116.5 35)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.121 36.752l1.317-.527a.896.896 0 00-.332-1.725H95.25a.75.75 0 000 1.5h.836a1 1 0 01.707.293l.197.197c.305.305.77.38 1.155.188l1.144-.572a.993.993 0 01.447-.106h.528c.155 0 .308.036.447.106l1.236.618a.382.382 0 00.553-.342c0-.211.171-.382.382-.382h.669c.275 0 .527.156.65.402.169.338.569.49.92.35z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35.5c0 .994.024 1.761.238 2.286.099.243.23.407.403.517.176.113.442.197.859.197.99 0 2.13-.008 3.026-.396.433-.188.791-.459 1.045-.852.254-.394.429-.951.429-1.752s-.175-1.358-.429-1.752c-.254-.393-.612-.664-1.045-.852-.896-.388-2.036-.396-3.026-.396-.417 0-.683.084-.859.197-.173.11-.304.274-.403.517-.214.525-.238 1.292-.238 2.286z",
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b"
  })));
}
export default SvgMaintenance;